import { Chip, ChipProps } from '@mui/material'

const OrderChip = ({ status, ...rest }: { status?: string } & ChipProps) => {
  const grey = { color: 'text.secondary', backgroundColor: 'action.hover' }
  const blue = { color: 'primary.main', backgroundColor: 'primary.shades.8p' }
  const green = { color: 'success.dark', backgroundColor: 'success.shades.8p' }
  const red = { color: 'error.main', backgroundColor: 'error.shades.12p' }

  const styleMap: Record<string, object | undefined> = {
    submitted: grey,
    'invoice sent': grey,
    'return created': grey,

    fulfilled: blue,
    shipped: blue,
    received: blue,

    'invoice paid': green,
    delivered: green,
    ordered: green,
    'received in full': green,

    cancelled: red,
    'delivery exception': red,
    discrepant: red,
    'no items found': red,
  }

  const lookupKey = status?.toLowerCase() ?? (typeof rest.label === 'string' ? rest.label?.toLowerCase() : '')
  const style = styleMap[lookupKey] ?? grey

  return <Chip {...rest} sx={style} />
}

export default OrderChip
